// Initialize logger first before any other imports
import React from 'react';

import '@mantine/core/styles.css';
import { type GitMetadata, gitMetadata } from '@teo/types';
import ReactDOM from 'react-dom/client';

import App from './App';
import './index.css';
import './utils/logger';

/**
 * React Application Entry Point
 * Intent: Initialize the TEO Property Management React application
 * Sets up React 18 with modern concurrent features and error handling
 */

// Expose version information on window for debugging
declare global {
  interface Window {
    __TEO_VERSION__: GitMetadata;
  }
}
window.__TEO_VERSION__ = gitMetadata;

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
